// extracted by mini-css-extract-plugin
export default {"header":"Header_header__pmsFP","right-block":"Header_right-block__oAgyN"};